var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurgerMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.625 15.5C3.625 15.3342 3.69085 15.1753 3.80806 15.0581C3.92527 14.9408 4.08424 14.875 4.25 14.875H16.75C16.9158 14.875 17.0747 14.9408 17.1919 15.0581C17.3092 15.1753 17.375 15.3342 17.375 15.5C17.375 15.6658 17.3092 15.8247 17.1919 15.9419C17.0747 16.0592 16.9158 16.125 16.75 16.125H4.25C4.08424 16.125 3.92527 16.0592 3.80806 15.9419C3.69085 15.8247 3.625 15.6658 3.625 15.5ZM3.625 10.5C3.625 10.3342 3.69085 10.1753 3.80806 10.0581C3.92527 9.94085 4.08424 9.875 4.25 9.875H16.75C16.9158 9.875 17.0747 9.94085 17.1919 10.0581C17.3092 10.1753 17.375 10.3342 17.375 10.5C17.375 10.6658 17.3092 10.8247 17.1919 10.9419C17.0747 11.0592 16.9158 11.125 16.75 11.125H4.25C4.08424 11.125 3.92527 11.0592 3.80806 10.9419C3.69085 10.8247 3.625 10.6658 3.625 10.5ZM3.625 5.5C3.625 5.33424 3.69085 5.17527 3.80806 5.05806C3.92527 4.94085 4.08424 4.875 4.25 4.875H16.75C16.9158 4.875 17.0747 4.94085 17.1919 5.05806C17.3092 5.17527 17.375 5.33424 17.375 5.5C17.375 5.66576 17.3092 5.82473 17.1919 5.94194C17.0747 6.05915 16.9158 6.125 16.75 6.125H4.25C4.08424 6.125 3.92527 6.05915 3.80806 5.94194C3.69085 5.82473 3.625 5.66576 3.625 5.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerMenuIcon);
export default __webpack_public_path__ + "static/media/burger-menu-icon.23919b99ef10bd0384dfd87621661f70.svg";
export { ForwardRef as ReactComponent };